// extracted by mini-css-extract-plugin
module.exports = {"table":"OutpatientAudit_table__1Kk0O","total":"OutpatientAudit_total__1heQa"};